// extracted by mini-css-extract-plugin
export var boldFontWeight = "700";
export var closeWrapper = "gF_yh";
export var closeWrapperMobile = "gF_yj";
export var container = "gF_g";
export var containerIcon = "gF_yf";
export var containerMobile = "gF_yg";
export var desktopQuery = "screen and (min-width: 60rem)";
export var extraLargeDesktopQuery = "screen and (min-width: 120rem)";
export var fontFamily = "Neuzeit Grotesk";
export var fontStack = "Neuzeit Grotesk,Helvetica Neue,Helvetica,Arial,sans-serif";
export var harbourBoldFontFamily = "ITC Avant Garde Pro Demi";
export var harbourBoldFontStack = "ITC Avant Garde Pro Demi,sans-serif";
export var harbourBoldFontWeight = "600";
export var harbourRegularFontFamily = "ITC Avant Garde Pro Bk";
export var harbourRegularFontStack = "ITC Avant Garde Pro Bk,sans-serif";
export var harbourRegularFontWeight = "300";
export var headerDesktopQuery = "screen and (min-width: 64rem)";
export var hoverQuery = "(hover: hover)";
export var landscapeQuery = "(orientation: landscape)";
export var largeDesktopQuery = "screen and (min-width: 90rem)";
export var largeTabletQuery = "screen and (min-width: 48rem)";
export var lightFontWeight = "300";
export var link = "gF_W";
export var maxExtraLargeDesktopScreen = "120rem";
export var maxHeaderMobileScreen = "64rem";
export var maxLargeDesktopScreen = "90rem";
export var maxLargeTabletScreen = "60rem";
export var maxMobileScreen = "30rem";
export var maxSmallTabletScreen = "48rem";
export var maxWideDesktopScreen = "80rem";
export var openCloseWrapper = "gF_yd";
export var portraitQuery = "(orientation: portrait)";
export var promoMarkdown = "gF_yc";
export var reducedMotionQuery = "(prefers-reduced-motion)";
export var regularFontWeight = "400";
export var removeText = "gF_yk";
export var smallTabletQuery = "screen and (min-width: 30rem)";
export var textWrapper = "gF_gx";
export var wideDesktopQuery = "screen and (min-width: 80rem)";
export var wrapper = "gF_B";